import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Formation from "@/pages/Formation";
import OutilsApps from "@/pages/OutilsApps";
import ProductDetail from "@/pages/ProductDetail";
import Ressources from "@/pages/Ressources";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Books from "@/pages/Books";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MonEspace from "@/pages/MonEspace";
import Panier from "@/pages/Panier";
import LearnPlayer from "@/pages/LearnPlayer";
import QcmPage from "@/pages/QcmPage";
import VerifyPage from "@/pages/VerifyPage";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import NotFound from "@/pages/NotFound";
import Legal from "@/pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const bare = ["/connexion", "/inscription"].includes(pathname);
  return (
    <>
      {!bare && <Navbar />}
      <main>{children}</main>
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
          <SmoothScroll />
          <ScrollToTop />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/expertise" element={<Services />} />
              <Route path="/services" element={<Services />} />
              <Route path="/formation" element={<Formation />} />
              <Route path="/outils-apps" element={<OutilsApps />} />
              <Route path="/outils-apps/:slug" element={<ProductDetail />} />
              <Route path="/panier" element={<Panier />} />
              <Route path="/formation/:lookup/apprendre" element={<ProtectedRoute><LearnPlayer /></ProtectedRoute>} />
              <Route path="/formation/:lookup/qcm" element={<ProtectedRoute><QcmPage /></ProtectedRoute>} />
              <Route path="/verify/:number" element={<VerifyPage />} />
              <Route path="/ressources" element={<Ressources />} />
              <Route path="/livres" element={<Books />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/connexion" element={<Login />} />
              <Route path="/inscription" element={<Register />} />
              <Route path="/mon-espace" element={<ProtectedRoute><MonEspace /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route path="/majdi-zarougui" element={<Profile />} />
              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/confidentialite" element={<Legal />} />
              <Route path="/cgu" element={<Legal />} />
              <Route path="/cgv" element={<Legal />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Chrome>
          <Toaster position="bottom-right" theme="dark" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
